import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { HeaderService } from '../../../../core/services/header.service';
import { Title, Meta } from '@angular/platform-browser';
import { MenuEnum } from 'src/app/shared/enum/menu-enum';
import { Router } from '@angular/router';
import { IdiomaService } from 'src/app/core/services/idioma.service';

@Component({
  selector: 'app-inicial-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  data: any;
 
  constructor(
    private translate: TranslateService,
    private headerService: HeaderService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    public idiomaService: IdiomaService,
    private gaService: GoogleAnalyticsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.headerService.carregarMenu(MenuEnum.HOME);
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.HOME').subscribe(
      res => {
        this.data = res;
        this.titleService.setTitle(this.data.HEADER_TITLE);
        this.meta.updateTag({ name: 'description', content: this.data.META_DESCRIPTION });
        this.meta.updateTag({ name: 'keywords', content: this.data.META_KEYWORDS });
        this.gaService.pageView(this.router.url);
      });
  }

}
